import { render, staticRenderFns } from "./PsiFilterData.vue?vue&type=template&id=5436b47b&scoped=true"
import script from "./PsiFilterData.vue?vue&type=script&lang=js"
export * from "./PsiFilterData.vue?vue&type=script&lang=js"
import style0 from "./PsiFilterData.vue?vue&type=style&index=0&id=5436b47b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5436b47b",
  null
  
)

export default component.exports